import { toast } from "react-toastify";
import fetcher from "../../lib/fetcher";
import useSWRMutation from "swr/mutation";

const useDealCancelRequest = (id: number) => {
  async function dealCancel(
    url: string,
    { arg }: { arg: { comment: undefined | string } }
  ) {
    try {
      const data = await fetcher.swr(url, {
        method: "PATCH",
        data: { comment: arg.comment },
      });

      return data.result;
    } catch (error: any) {
      toast.error(
        `Что-то не так. Не удалось отменить заявку, попробуйте позже: ${error}`
      );
      throw new Error(error);
    }
  }

  const { data, error, isMutating, trigger } = useSWRMutation(
    `/deal-request/${id}/reject`,
    dealCancel
  );

  return { data: data, error, isMutating, trigger };
};

export default useDealCancelRequest;
